import view from './view.html';

/* @ngInject */
export default function ($rootScope, PageHeaderService) {
	return {
		restrict: 'A',
		template: view,
		link:     (scope) => {
			scope.update = function () {
				scope.title         = PageHeaderService.getTitle();
				scope.subtitle      = PageHeaderService.getSubtitle();
				scope.description   = PageHeaderService.getDescription();
				scope.breadcrumbs   = PageHeaderService.getBreadcrumbs();
				scope.actionButtons = PageHeaderService.getActionButtons();
			};

			$rootScope.$on('pageHeaderService.updated', scope.update);

			scope.update();

			scope.actionButtonClicked = function (index) {
				PageHeaderService.fireClickedEvent(index);
			};
		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/pageHeader/index.js